import { dateRangePickerFields } from "../../filters/components/DateRangePicker";
import {
  FILTER_TYPES,
  ReportFilterConfigBase,
} from "../../filters/config/types";

export const Filters: ReportFilterConfigBase[] = [
  {
    label: "Search by Shop or Client",
    type: FILTER_TYPES.Query,
    fields: "search",
    fetchReportOnEnterPress: true,
  },
  {
    label: "Supplier",
    type: FILTER_TYPES.Supplier,
    fields: "division_id",
  },
  {
    label: "Client",
    type: FILTER_TYPES.Client,
    fields: "client_id",
  },
  {
    label: "Date",
    type: FILTER_TYPES.DateRange,
    fields: dateRangePickerFields,
    defaultValue: ["", "", ""],
  },
];
